export function getCategoryTitle(category) {
    return category?.title ?? category?.name ?? "";
}

export function getCategorySlug(category) {
    return category?.slug ?? category?.url ?? "";
}
